module.exports = __webpack_public_path__ + "static/media/mini_audi_2.75638c6a.jpg";